// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html{
    font-size: 16px;
}

.react-datepicker{
    border-radius: 0;
}
.react-datepicker__day {
     border-radius: 0 !important;
}
.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__day--keyboard-selected {
     background-color: #1E746F;
}
.react-datepicker__input-container{
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/common/styles/datepicker-restyle.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;KACK,2BAA2B;AAChC;AACA;;;;KAIK,yBAAyB;AAC9B;AACA;IACI,cAAc;AAClB","sourcesContent":["html{\n    font-size: 16px;\n}\n\n.react-datepicker{\n    border-radius: 0;\n}\n.react-datepicker__day {\n     border-radius: 0 !important;\n}\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__day--keyboard-selected {\n     background-color: #1E746F;\n}\n.react-datepicker__input-container{\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
